import type { FieldErrors } from "react-hook-form";

import type { SegmentFormValues } from "./schemas";

export const INVALID_LOGIC_RADIO_SELECTOR = '[role="radiogroup"][aria-invalid="true"] [role="radio"]';

export const hasInvalidLogic = (
  errors: FieldErrors<SegmentFormValues>,
  values: SegmentFormValues,
): boolean => !!errors.type || values.rules.some((_, ruleIndex) => !!errors.rules?.[ruleIndex]?.type);

export const findFirstInvalidConditionKey = (
  errors: FieldErrors<SegmentFormValues>,
  values: SegmentFormValues,
): string | undefined => {
  for (const [ruleIndex, rule] of values.rules.entries()) {
    const conditionErrors = errors.rules?.[ruleIndex]?.conditions;
    const invalid = rule.conditions.find((_, conditionIndex) => conditionErrors?.[conditionIndex]);
    if (invalid) return invalid.clientKey;
  }
  return undefined;
};
